module.exports = {
  messages: {
    CN: {
      "orderList.orderKeyword": "订单信息",
      "orderList.orderKeyword_placeholder": "请输入订单编号",
      "orderList.customerKeyword": "得意先信息",
      "orderList.customerKeyword_placeholder": "邮箱/电话/名称/收货人姓名/收货人电话/得意先编号",
      //姓名/收货人电话
      "orderList.customerKeyword_placeholder2": "得意先名称/收货人姓名/收货人电话/得意先编号",
      //姓名/收货人电话
      "orderList.productKeyword": "商品信息",
      "orderList.productKeyword_placeholder": "请输入商品编号/商品名称",
      "orderList.TotalAmount": "订单金额",
      "orderList.payId": "支付方式",
      "orderList.orderStatus": "订单状态",
      "orderList.expressNo": "物流编号",
      "orderList.OrderDate": "下单日期",
      "orderList.SendTime": "预计发货日",
      "orderList.expressStatus": "物流状态",
      "orderList.ArriveDate": "希望到货日期",
      "orderList.deliveryChannelId": "发货渠道",
      "orderList.colOrderNo": "订单编号",
      "orderList.colERPNo": "传票番号",
      "orderList.colCustomer": "得意先信息",
      "orderList.colOrderStatus": "订单状态",
      "orderList.ColTotalAmount": "订单金额（含税）",
      "orderList.ColPayTitle": "支付方式",
      "orderList.ColLangTitle": "下单语言",
      "orderList.ColChannelTitle": "发货渠道",
      "orderList.colOrderDate": "下单日期",
      "orderList.ColArriveDate": "希望到货日期",
      "orderList.colPlanSendTime": "预计发货日",
      "orderList.colCustomerNote": "得意先备注",
      "orderList.colOrderTransportInfo": "物流信息",
      "orderList.colOperatorNote": "客服备注",
      "orderList.colOrderSource": "订单来源",
      "orderList.userAgent": "客户端类型",
      "orderList.btnOrderStatus": "订单状态",
      "orderList.btnExportOrder": "导出订单",
      "orderList.btnExpress": "刷新物流",
      "orderList.btnPlanSendTime": "预计发货日",
      "orderList.details": "详情",
      "orderList.actionOperatorNote": "客服备注",
      "orderList.actionCancel": "取消",
      "orderList.actionCanceltitle": "确定取消订单吗？",
      "orderList.editOrderStatusNotice": "通知用户",
      "orderList.noselectedRowKey": "请选择订单",
      "orderList.noselectedRowKey2": "请选择传票",
      "orderList.editOrderTitle": "修改订单状态",
      "orderList.editOrderStatusNoStatus": "请选择状态",
      "orderList.editSendDateTitle": "设置预计发货日",
      "orderList.sendDateNoDate": "请选择预计发货日",
      "orderList.addOrderNoteTitle": "添加客服备注",
      "orderList.orderNote": "备注内容",
      "orderList.noOrderNote": "请填写备注内容",
      "orderList.tips": "温馨提示",
      "orderList.tipsContent": "订单状态一旦改成已发货，将不可逆",
      "orderList.statusTipsContent": "待支付可变更为待处理 <br/> 待处理可变更为发货准备 <br/> 发货准备可变更为待处理、拣货中、已发货 <br/> 拣货中可变更为发货准备、已发货 <br/> 已发货可变更为已完成、已返品 <br/>",
      "orderList.deliveryMethod1": '引取',
      "orderList.deliveryMethod2": '郵送',
      "orderList.deliveryMethod3": '自社便',
      'orderList.deliveryMethod': '货运方式',
      'orderList.ddz': '担当者',
      "orderList.payMethod1": '现金',
      "orderList.payMethod2": '月结',
      "orderList.payMethod3": '货到付款',
      "orderList.mergeMainOrder": '合并主订单',
      "orderList.mergeContent": '该订单已经合并到{orderNo}订单中，请点击',
      "orderList.erpContent": '传票信息',
      "orderList.erpContentPl": '请输入传票番号',
      "orderList.erpTicketStatus": '传票状态',
      "orderList.erpTransport": '运输公司',
      "orderList.erpAmount": '传票金额',
      "orderList.creatDate": '创建日期',
      "orderList.erpAmount2": '传票金额',
      "orderList.suiba": "(税拔)",
      "orderList.suiru": "(税込)",
      "orderList.flushSuccess": '刷新成功',
      "orderDetailTransport.noModeOfTransport2": "该物流公司不支持查询物流状态，请耐心等待配送",
      "orderList.syncErpOrders": '同步传票',
      "orderList.cashOnDeliveryAmount": '代引金额',
      "orderList.mainAgent": '主代引',
      "orderList.syncOrders": '同步订单',
      "orderList.showNpsDownloadTip": "纳品书显示设置成功",
      "orderList.npsshow": "纳品书",
      "orderList.npsYes": "已显示",
      "orderList.npsNo": "未显示",
      "orderList.shownps": "显示"
    },
    JP: {
      "orderList.orderKeyword": "注文情報",
      "orderList.orderKeyword_placeholder": "注文番号を入力してください",
      "orderList.customerKeyword": "得意先情報",
      "orderList.customerKeyword_placeholder": "メール/電話/名前/受取人名/受取人電話/得意先コード",
      //姓名/收货人电话
      "orderList.customerKeyword_placeholder2": "得意先名/受取人名/受取人電話/得意先コード",
      //姓名/收货人电话
      "orderList.productKeyword": "商品情報",
      "orderList.productKeyword_placeholder": "商品コード/商品名を入力してください",
      "orderList.TotalAmount": "订单金额",
      "orderList.payId": "支払方法",
      "orderList.orderStatus": "注文状態",
      "orderList.expressNo": "物流番号",
      "orderList.OrderDate": "注文日",
      "orderList.SendTime": "预计发货日",
      "orderList.expressStatus": "物流状態",
      "orderList.ArriveDate": "希望配達日",
      "orderList.deliveryChannelId": "发货渠道",
      "orderList.colOrderNo": "注文番号",
      "orderList.colERPNo": "伝票番号",
      "orderList.colCustomer": "得意先情報",
      "orderList.colOrderStatus": "注文状態",
      "orderList.ColTotalAmount": "订单金额（税込）",
      "orderList.ColPayTitle": "支払方法",
      "orderList.ColLangTitle": "下单语言",
      "orderList.ColChannelTitle": "发货渠道",
      "orderList.colOrderDate": "注文日",
      "orderList.ColArriveDate": "希望配達日",
      "orderList.colPlanSendTime": "预计发货日",
      "orderList.colCustomerNote": "得意先備考",
      "orderList.colCustomerNote2": "注文メモ",
      "orderList.colOrderTransportInfo": "物流情報",
      "orderList.colOperatorNote": "客服备注",
      "orderList.colOrderSource": "订单来源",
      "orderList.userAgent": "クライアントタイプ",
      "orderList.btnOrderStatus": "注文状態",
      "orderList.btnExportOrder": "导出订单",
      "orderList.btnExpress": "最新の物流情報を取得",
      "orderList.btnPlanSendTime": "预计发货日",
      "orderList.details": "詳細",
      "orderList.actionOperatorNote": "客服备注",
      "orderList.actionCancel": "キャンセル",
      "orderList.actionCanceltitle": "确定取消订单吗？",
      "orderList.editOrderStatusNotice": "通知用户",
      "orderList.noselectedRowKey": "请选择订单",
      "orderList.noselectedRowKey2": "伝票を選択してください",
      "orderList.editOrderTitle": "修改订单状态",
      "orderList.editOrderStatusNoStatus": "请选择状态",
      "orderList.editSendDateTitle": "设置预计发货日",
      "orderList.sendDateNoDate": "请选择预计发货日",
      "orderList.addOrderNoteTitle": "添加客服备注",
      "orderList.orderNote": "备注内容",
      "orderList.noOrderNote": "请填写备注内容",
      "orderList.tips": "ヒント",
      "orderList.tipsContent": "订单状态一旦改成已发货，将不可逆",
      "orderList.statusTipsContent": "待支付可变更为待处理 <br/> 待处理可变更为发货准备 <br/> 发货准备可变更为待处理、拣货中、已发货 <br/> 拣货中可变更为发货准备、已发货 <br/> 已发货可变更为已完成、已返品 <br/>",
      "orderList.deliveryMethod1": '自取り',
      "orderList.deliveryMethod2": '郵送',
      "orderList.deliveryMethod3": '自社便',
      'orderList.deliveryMethod': '配送方法',
      'orderList.ddz': '担当者',
      "orderList.payMethod1": '現金',
      "orderList.payMethod2": '月末締め',
      "orderList.payMethod3": '代金引換',
      "orderList.mergeMainOrder": '合并主订单',
      "orderList.mergeContent": '该订单已经合并到{orderNo}订单中，请点击',
      "orderList.erpContent": '伝票情報',
      "orderList.erpContentPl": '伝票番号を入力してください',
      "orderList.erpTicketStatus": '伝票状態',
      "orderList.erpTransport": '運送会社',
      "orderList.erpAmount": '伝票金額',
      "orderList.creatDate": '作成日',
      "orderList.erpAmount2": '伝票金額',
      "orderList.suiba": "(税拔)",
      "orderList.suiru": "(税込)",
      "orderList.flushSuccess": '更新成功',
      "orderDetailTransport.noModeOfTransport2": "ご利用中の配達サービスが追跡できないため、配送をお待ちください",
      "orderList.syncErpOrders": '伝票を同期する',
      "orderList.cashOnDeliveryAmount": '代引金額',
      "orderList.mainAgent": 'まとめ代引',
      "orderList.cacelTip": "キャンセルした注文を戻すことができません。",
      "orderList.cancelOk": "注文をキャンセルしました",
      "orderList.showNpsDownloadTip": "納品書の表示設定が完了しました",
      "orderList.npsshow": "納品書",
      "orderList.npsYes": "表示中",
      "orderList.npsNo": "非表示",
      "orderList.shownps": "表示"
    }
  }
};